__turbopack_context__.v({
  "DM_12_24_Link_B": "Button-module-scss-module__gW1A4G__DM_12_24_Link_B",
  "DM_14_24_Link_B": "Button-module-scss-module__gW1A4G__DM_14_24_Link_B",
  "DM_20_24_Bold": "Button-module-scss-module__gW1A4G__DM_20_24_Bold",
  "DM_Body_Reg_16": "Button-module-scss-module__gW1A4G__DM_Body_Reg_16",
  "DM_Bold_14_16": "Button-module-scss-module__gW1A4G__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "Button-module-scss-module__gW1A4G__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "Button-module-scss-module__gW1A4G__DM_Bold_16_24",
  "DM_Bold_20_24": "Button-module-scss-module__gW1A4G__DM_Bold_20_24",
  "DM_Bold_40_56": "Button-module-scss-module__gW1A4G__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "Button-module-scss-module__gW1A4G__DM_Btn_16_16_Med",
  "DM_Med_10_12": "Button-module-scss-module__gW1A4G__DM_Med_10_12",
  "DM_Med_12_12_Chip": "Button-module-scss-module__gW1A4G__DM_Med_12_12_Chip",
  "DM_Med_12_16": "Button-module-scss-module__gW1A4G__DM_Med_12_16",
  "DM_Med_14_16": "Button-module-scss-module__gW1A4G__DM_Med_14_16",
  "DM_Med_14_20": "Button-module-scss-module__gW1A4G__DM_Med_14_20",
  "DM_Med_14_24": "Button-module-scss-module__gW1A4G__DM_Med_14_24",
  "DM_Med_16_16": "Button-module-scss-module__gW1A4G__DM_Med_16_16",
  "DM_Med_16_24": "Button-module-scss-module__gW1A4G__DM_Med_16_24",
  "DM_Med_18_24": "Button-module-scss-module__gW1A4G__DM_Med_18_24",
  "DM_Med_20_24": "Button-module-scss-module__gW1A4G__DM_Med_20_24",
  "DM_Med_24_24": "Button-module-scss-module__gW1A4G__DM_Med_24_24",
  "DM_Med_32_32": "Button-module-scss-module__gW1A4G__DM_Med_32_32",
  "DM_Med_32_48": "Button-module-scss-module__gW1A4G__DM_Med_32_48",
  "DM_Med_8_8": "Button-module-scss-module__gW1A4G__DM_Med_8_8",
  "DM_Reg_10_10": "Button-module-scss-module__gW1A4G__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "Button-module-scss-module__gW1A4G__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "Button-module-scss-module__gW1A4G__DM_Reg_12_16",
  "DM_Reg_14_16": "Button-module-scss-module__gW1A4G__DM_Reg_14_16",
  "DM_Reg_14_24": "Button-module-scss-module__gW1A4G__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "Button-module-scss-module__gW1A4G__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "Button-module-scss-module__gW1A4G__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "Button-module-scss-module__gW1A4G__DM_Reg_16_20",
  "DM_Reg_16_24": "Button-module-scss-module__gW1A4G__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "Button-module-scss-module__gW1A4G__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "Button-module-scss-module__gW1A4G__DM_Reg_18_28",
  "DM_Reg_32_32": "Button-module-scss-module__gW1A4G__DM_Reg_32_32",
  "DM_Reg_40_56": "Button-module-scss-module__gW1A4G__DM_Reg_40_56",
  "animated": "Button-module-scss-module__gW1A4G__animated",
  "blue": "Button-module-scss-module__gW1A4G__blue",
  "button": "Button-module-scss-module__gW1A4G__button",
  "buttonContent": "Button-module-scss-module__gW1A4G__buttonContent",
  "dashed": "Button-module-scss-module__gW1A4G__dashed",
  "dashedGray": "Button-module-scss-module__gW1A4G__dashedGray",
  "expanded": "Button-module-scss-module__gW1A4G__expanded",
  "fullWidth": "Button-module-scss-module__gW1A4G__fullWidth",
  "ghost": "Button-module-scss-module__gW1A4G__ghost",
  "gray": "Button-module-scss-module__gW1A4G__gray",
  "icon": "Button-module-scss-module__gW1A4G__icon",
  "leftIcon": "Button-module-scss-module__gW1A4G__leftIcon",
  "linkBlack": "Button-module-scss-module__gW1A4G__linkBlack",
  "linkBlue": "Button-module-scss-module__gW1A4G__linkBlue",
  "linkRed": "Button-module-scss-module__gW1A4G__linkRed",
  "loader": "Button-module-scss-module__gW1A4G__loader",
  "medium": "Button-module-scss-module__gW1A4G__medium",
  "noUnderline": "Button-module-scss-module__gW1A4G__noUnderline",
  "redAlert": "Button-module-scss-module__gW1A4G__redAlert",
  "rightIcon": "Button-module-scss-module__gW1A4G__rightIcon",
  "small": "Button-module-scss-module__gW1A4G__small",
  "tertiary": "Button-module-scss-module__gW1A4G__tertiary",
  "vertical": "Button-module-scss-module__gW1A4G__vertical",
  "visible": "Button-module-scss-module__gW1A4G__visible",
  "white": "Button-module-scss-module__gW1A4G__white",
  "whiteAlert": "Button-module-scss-module__gW1A4G__whiteAlert",
});
